import React, { useState } from 'react';
import { Linking, StyleSheet, Text, View } from 'react-native';
import { sendTestWorkerCommand } from '../../runtime/mobile/testWorkerClient';
import { readableMobileError } from '../../runtime/mobile/employeeRuntimeState';
import { colors, spacing, typography } from '../../config/theme';
import { Card, PrimaryButton } from '../ui';

// Lets an employee bind their Telegram chat to their account. The worker mints a
// short-lived signed deep link; opening it triggers the bot webhook, which
// writes users/{uid}.telegramChatId. AuthContext subscribes to the profile
// live, so this card flips to the linked state on its own once that lands.
export default function TelegramLinkCard({ user }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [opened, setOpened] = useState(false);

  const connect = async () => {
    setBusy(true);
    setError(null);
    try {
      const { url } = await sendTestWorkerCommand({
        user,
        path: '/commands/link-telegram',
        body: {},
        idempotencyKey: `emp:${user.uid}:tglink:${Date.now()}`,
      });
      if (!url) throw new Error('NO_LINK');
      await Linking.openURL(url);
      setOpened(true);
    } catch (e) {
      setError(readableMobileError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card>
      <Text style={styles.title}>Уведомления в Telegram</Text>
      <Text style={styles.sub}>
        Подключите Telegram, чтобы получать напоминания о выходе на смену и задачах.
      </Text>
      <View style={{ marginTop: spacing.md }}>
        <PrimaryButton title={opened ? 'Открыть Telegram ещё раз' : 'Подключить Telegram'} loading={busy} onPress={connect} />
      </View>
      {opened && !error && (
        <Text style={styles.hint}>
          В Telegram нажмите «Запустить» / Start. Когда бот ответит, здесь появится отметка о подключении.
        </Text>
      )}
      {error && <Text style={styles.err}>{error}</Text>}
    </Card>
  );
}

export function TelegramLinkedNote() {
  return (
    <Card>
      <Text style={styles.linked}>✓ Telegram подключён</Text>
      <Text style={styles.sub}>Напоминания по сменам приходят вам в Telegram.</Text>
    </Card>
  );
}

const styles = StyleSheet.create({
  title: { ...typography.h3, color: colors.textPrimary },
  linked: { ...typography.h3, color: colors.primary },
  sub: { ...typography.body, color: colors.textSecondary, marginTop: 2 },
  hint: { ...typography.caption, color: colors.textMuted, marginTop: spacing.sm },
  err: { ...typography.caption, color: colors.danger, marginTop: spacing.sm },
});
